import { Button } from "@sylviq/ui-react-web/components/ui/button";

interface StatusFilterOption {
  value: string;
  label: string;
  count?: number;
}

/** Fixed filter for one list. The choices stay put when a status has no rows. */
export function StatusFilter({
  label,
  value,
  onChange,
  options,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: StatusFilterOption[];
}) {
  return (
    <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
      {options.map((option) => {
        const selected = value === option.value;
        const count =
          option.count === undefined ? "" : ` (${option.count})`;
        return (
          <Button
            key={option.value || "all"}
            type="button"
            role="radio"
            aria-checked={selected}
            size="sm"
            variant={selected ? "primary" : "secondary"}
            onClick={() => onChange(option.value)}
          >
            {option.label}
            {count}
          </Button>
        );
      })}
    </div>
  );
}
